import * as React from "react";
import {useState} from "react";
import {connect} from "react-redux";
import {getParamInfo, getParamScoreResult} from "creditreport/utils";
import Modal from "components/Modal";

interface IConnectProps {
    userId: number;
    config: any;
}
interface IDispatchProps {
    dispatch?: (action: any) => void;
}
interface IProps {
    creditParam: string;
    creditParamScore: string;
}
type FinalProps = IDispatchProps & IProps & IConnectProps;

function CreditParameter(props: FinalProps) {
    const [modalActive, updateModalActive] = useState<boolean>(false);
    const paramInfo = getParamInfo(props.creditParam);
    const paramResult = getParamScoreResult(props.creditParamScore);
    const paramInfoMessage = getParamInfo(props.creditParam);

    function paramScoreResult() {
        return props.creditParamScore.charAt(0) + props.creditParamScore.substr(1).toLowerCase();
    }
    function handleDataToggle() {
        if (!modalActive) {
            updateModalActive(true);
        } else {
            updateModalActive(false);
        }
    }
    return(
        <div className="progress-container display-inline">
            <div className="row">
                <div className="col">
                    <div className="float-left card-left-text">
                        {props.creditParam}
                    </div>
                    <div className="float-right item-text-right"
                         onClick={() => handleDataToggle()}
                         data-content={paramInfo}>
                        Know more
                    </div>
                </div>
            </div>
            <div className="progress">
                <div className={paramResult.scoreClass} role="progressbar"
                     style={{width: paramResult.scoreValue + "%"}}
                     aria-valuenow={paramResult.scoreValue} aria-valuemin={0}
                     aria-valuemax={100}>
                </div>
            </div>
            <span className="card-bottom-text float-left">Status: {paramScoreResult()}</span>
            <span className="card-bottom-text float-right">{paramResult.scoreValue}%</span>
            <Modal
                title={props.creditParam}
                active={modalActive}
                children={paramInfoMessage}
                cancellable={true}
                onClose={handleDataToggle}
            />
        </div>
    );
}

const mapStateToProps = (state): IConnectProps => {
    const auth = state.login.auth ? state.login.auth : null;
    return {
        userId: auth.userId,
        config: state.userform.config,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(CreditParameter);
